module.exports = __webpack_public_path__ + "img/proyecto_13_mv.eee35e6e.webp";